import { createSurveyStyles } from '@sm/webassets';

const useSurveyStyles = createSurveyStyles(theme => ({
  pageTitle: {
    color: theme?.titleColor,
    lineHeight: 1.25,
    ...theme?.pageTitle,
    // reset font weight changed by the theme above
    '& strong': {
      fontWeight: 'bold !important',
    },
  },
}));

export default useSurveyStyles;
